import {
  BaseService
} from "./BaseService";
import {
  SnackBarModule
} from "../modules/SnackBarModule";

export const HistoricoFeriasService = {

  
  async getExercicio(idSigrh) {
    const response = await BaseService.fetchResponseFromAPIGet(`historico-ferias/exercicios/${idSigrh}`);
    if (response.error) {
      SnackBarModule("Houve um erro ao listar os exercícios", "error");
    }
    return response.content;
  },

  async feriasAnuais(postData, idSigrh) {

    const response = await BaseService.fetchResponseFromAPIPost(
      `ferias/historico/ferias-anuais/${idSigrh}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    return response.message;
  },


  async pesquisar(postData, idSigrh) {

    const response = await BaseService.fetchResponseFromAPIPost(
      `historico-ferias/solicitante/${idSigrh}`,
      postData,
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    return response.message;
  },

  async historicoComplementar(postData,idSigrh) {

    const response = await BaseService.fetchResponseFromAPIPost(
      `historico-ferias/complementar/${idSigrh}`,
      postData
    );
    if (response.error) {
      SnackBarModule(response.message, "error");
      return false;
    }
    return response.message;
  },

}